const commonData = {
    smallimg:'?x-oss-process=image/resize,m_fill,h_50,w_50',
    // headerColor:"#606266"
}

export default commonData;